<template>
  <div class="page-container">
    <div class="page-title">
      {{ $t('menu.online_large_payout') }}
    </div>
    <LargePayoutApprovalStep />
  </div>
</template>

<script>
export default {
  name: 'Payout_Approval',
  components: {
    LargePayoutApprovalStep: () => import('./components/LargePayoutApprovalStep.vue')
  }
}
</script>

<style scoped>

</style>
